import React from "react";
import Description from "./Description";
import Coaches from "./Coaches";
import Sporters from "./Sporters";
import Sponsors from "./Sponsors";
import "./AboutUs.css";
import Gallery from "./Gallery";
import Facebook from "./SocialMedia/Facebook";
import Instagram from "./SocialMedia/Instagram";

const AboutUs = () => {
  return (
    <div className="about-container">
      <div className="section-wrapper section-1">
        <Gallery />
      </div>
      <div className="section-wrapper section-2">
        <Description />
      </div>
      <div className="section-wrapper section-news">
        <div className="social-wrapper facebook">
          <Facebook facebookLink="https://www.facebook.com/profile.php?id=61578222267348" />
        </div>
        <div className="social-wrapper instagram">
          <Instagram instagramLink="https://www.instagram.com/goats_karate/" />
        </div>
      </div>
      <div className="section-wrapper section-3">
        <Coaches />
      </div>
      <div className="section-wrapper section-4">
        <Sporters />
      </div>
      <div className="section-wrapper section-5">
        <Sponsors />
      </div>
    </div>
  );
};

export default AboutUs;
